<template>
  <RouterView />
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useColors } from 'vuestic-ui'
import { useAutoLock } from './composables/useAutoLock'

const router = useRouter()
const { startAutoLock, stopAutoLock } = useAutoLock()
const { applyPreset } = useColors()

onMounted(async () => {
  // Charger le thème sauvegardé
  const savedTheme = localStorage.getItem('vuestic-theme')
  if (savedTheme && (savedTheme === 'dark' || savedTheme === 'light')) {
    applyPreset(savedTheme)
  }

  // Démarrer le verrouillage automatique si l'utilisateur est connecté
  const userStr = localStorage.getItem('user')
  console.log('[App] User connecté:', !!userStr)
  if (userStr) {
    console.log('[App] Démarrage du verrouillage automatique...')
    await startAutoLock()
  }
})

// Surveiller les changements de route pour gérer le verrouillage
watch(
  () => router.currentRoute.value.name,
  async (newRoute) => {
    const userStr = localStorage.getItem('user')
    const publicPages = ['login', 'signup', 'recover-password', 'recover-password-email']

    if (userStr && !publicPages.includes(newRoute as string)) {
      // Utilisateur connecté sur une page privée, activer le verrouillage auto
      console.log('[App] Route changée, activation du verrouillage...')
      await startAutoLock()
    } else {
      // Page publique ou pas connecté, désactiver le verrouillage auto
      console.log('[App] Route publique ou déconnecté, arrêt du verrouillage')
      stopAutoLock()
    }
  },
)

onUnmounted(() => {
  stopAutoLock()
})
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
